var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBB\x84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84",
    d: "M16.5763 16.3176C16.5661 16.2151 16.5621 16.1106 16.5621 16.0061C16.5621 14.0747 18.1426 12.5091 20.0924 12.5091C22.0422 12.5091 23.6227 14.0747 23.6227 16.0061C23.6227 16.1106 23.6166 16.2151 23.6085 16.3176H27.3032C27.3072 16.2151 27.3113 16.1106 27.3113 16.0061C27.3113 12.0569 24.0792 8.85529 20.0924 8.85529C16.1056 8.85529 12.8735 12.0569 12.8735 16.0061C12.8735 16.1106 12.8776 16.2151 12.8817 16.3176H16.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84_2",
    d: "M23.6229 14.0003L21.1293 16.3176H24.0733L23.6229 14.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84_3",
    d: "M19.6258 3.0912C17.8871 1.07136 15.357 0.116713 12.8756 0.28754V3.85693C14.3405 3.67605 15.8663 4.20262 16.8949 5.39845C18.0392 6.72893 18.2665 8.52769 17.6335 10.0391H21.3788C21.9023 7.66348 21.3403 5.08291 19.6258 3.0912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84_4",
    d: "M23.5497 18.5666C23.4705 23.9167 19.0698 28.2317 13.6485 28.2317C11.0394 28.2317 8.66957 27.2308 6.90036 25.5968C7.25339 25.6431 7.61454 25.6692 7.97973 25.6692C12.137 25.6692 15.5598 22.5621 16.0183 18.5666H12.4028C11.9767 20.6005 10.1608 22.1279 7.98176 22.1279C6.08676 22.1279 4.46566 20.9703 3.79408 19.3323L3.66626 18.9706H1.52588e-05C1.52588e-05 18.9726 1.52588e-05 18.9746 0.00204616 18.9786C0.353045 26.1455 6.32822 31.8493 13.6485 31.8493C21.1109 31.8493 27.1733 25.9244 27.3112 18.5666L23.5497 18.5666Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCollapse);
export default __webpack_public_path__ + "static/media/logoCollapse.9264d3cc2652805d5ae7cf83b8e40501.svg";
export { ForwardRef as ReactComponent };